//React
import React, { useEffect, useState } from "react";

//Internal Components
import Login from "./components/Login";
import TestFooter from "../../components/layouts/Footer/TestFooter";
import Header from "../../components/layouts/Header/Header";
import SEO from "../../components/seo/SEO";

//CSS
import "./loginscreen.css";

export default function ViewLoginScreen() {
  return (
    <>
      <SEO
        title="Log In"
        description="Log In to NoWastedDays to add to and update your journal, plan your week and review your insights."
        canonicalUrl="https://nowasteddays.io/login"
      />
      <Header variant="light" />
      <main id="registerScreen">
        <Login />
      </main>
      <TestFooter />
    </>
  );
}
